import React from 'react';
import { DesktopHeader } from './DesktopHeader';
import { MobilHeader } from './MobilHeader';

export const Header = () => {
    return (<>
        <DesktopHeader />
        <MobilHeader />
    </>

    )
}
